export default __webpack_public_path__ + "static/media/volcano.4f1a446e.svg";